import { Autocomplete } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import TextFieldCustom from "components/TextFieldCustom";
import Spinner from "components/spinner/Spinner";
import { USER_ROLES } from "constants";
import { displayNotification, formTypeCheck, sendAPIRequest } from "helpers";
import { useLazyGetSingleFormQuery } from "modules/pvs_activities/redux/service/forms";
import { useLazyGetListByMasterIdQuery, useLazyGetListByMasterKeyQuery } from "modules/pvs_activities/redux/service/lists";
import { useLazyGetMissionUsersQuery } from "modules/pvs_activities/redux/service/pvsaUser";
import { useGetRolesQuery } from "modules/pvs_activities/redux/service/roles";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MissionContext } from "../contexts/MissionTasksContext";
import { REPORT_ASSIGNMENT_STATUS, USER_TYPE } from "modules/pvs_activities/constants";
import dayjs from "dayjs"; 


const MissionWorkflowModal = ({ isShow, initModal, modalData, setModalData }) => {
  const { t } = useTranslation();
  const missionContext = useContext(MissionContext)
  const [missionActorCheck, setMissionActorCheck] = useState(true)
  const [missionActors, setMissionActors] = useState([])
  const [assignedUser, setAssignedUser] = useState(null)

  const { data: roleList } = useGetRolesQuery(
    {
      only: `3,5,${modalData.process_role_id ?? ''}`
    }
  );

  const getMissionActors = async () => {
    try {
      const data = await sendAPIRequest("/api/list/master/45?with_user=true&show_in_filter=true");
      const response = await data.json();
      if (response.success) {
        setMissionActors(response.data);
      }
    } catch (error) {
      console.error("Error fetching mission actors:", error);
    }

  }


  const [userTrigger, userRes] = useLazyGetMissionUsersQuery();

  const [isBtnLoading, setIsBtnLoading] = useState(false);
  // const [triggerAssignFor, assignForRes] = useLazyGetListByMasterIdQuery();
  const [triggerAssignFor, assignForRes] = useLazyGetListByMasterKeyQuery();
  const [triggerForm, formRes] = useLazyGetSingleFormQuery();
  const [newRoles, setNewRoles] = useState([]);

  useEffect(() => {
    getMissionActors()
  }, [])

  useEffect(() => {
    if (roleList) {
      let temp = [];
      if (!missionActorCheck) { // Fix flipped condition
        temp = roleList.map((role) => ({
          id: role.id,
          role_name: role.role_name,
        }));
        temp.push({
          id: 'mission_experts',
          role_name: "Mission Experts"
        });
        temp.push({
          id: 'mission_peer_reviewer',
          role_name: "Mission Peer Reviewers"
        });
        temp.push({
          id: 'mission_delegate',
          role_name: "Mission Delegate"
        });
      } else {
        temp = missionActors.map((actor) => ({
          id: actor.id,
          role_name: actor.list_element_name,
        }));
      }
      setNewRoles(temp);
    }
  }, [roleList, missionActorCheck, missionActors]);

  useEffect(() => {
    if (isShow) {
      triggerForm({ id: modalData.form_id, movementId: modalData.id }, true);
      userTrigger({
        roleId: modalData.role_id,
        missionId: modalData.mission_id,
        formId: modalData.form_id,
      });
      setModalData({ ...modalData });
    }
  }, [isShow]);

  useEffect(() => {
    userTrigger({
      roleId: modalData.role_id,
      missionId: modalData.mission_id,
      formId: modalData.form_id,
    });
  }, [modalData.role_id]);

  useEffect(() => {
    if (formRes.isSuccess && formRes.data.type_ref !== 'FT_FRM') {
      if (formTypeCheck(formRes.data.type_ref, { letter: true })) {
        triggerAssignFor({ key: "ASFO", params: { form_type_ref: formRes.data.type_ref, order_by: "id" } }, true);
      } else if (formTypeCheck(formRes.data.type_ref, { report: true })) {
        triggerAssignFor({ key: "RPTST", params: { order_by: "id", show_in_filter: 1 } }, true);
      }
    }
  }, [formRes]);
  useEffect(() => {
    const getAssignedUser = async () => {
      try {
        const ret = await sendAPIRequest(`/api/pvsa/mission-correspondence-cc/mission-actors/${modalData.mission_id}?role_status=actor`);
        const res = await ret.json();
        if (res.success && res.status === 200) {
          const user = res.data.find((item) => item.mission_actor_type === modalData.role_id);
          if (user?.user_id) {
            setAssignedUser({
              id: user.user_id,
              name: user.user_name,
            });
          } else {
            setAssignedUser(null)
          }
        }
      } catch (error) {
        console.error("Error fetching assigned user:", error);
        setAssignedUser(null)
      }
    };
    if (modalData.mission_id) {
      getAssignedUser();
    }
  }, [modalData.mission_id, modalData.role_id]);

  const userList = useMemo(() => {
    if (userRes.data) {
      return userRes.data;
    }
    return []
  }, [userRes]);

  const handlePopupValueChange = (val) => {
    setModalData({ ...modalData, user_id: val });
  };

  const handlePopupAssignForValueChange = (val) => {
    setModalData({ ...modalData, dform_assigned_for: val });
  };

  const handleRoleChange = (newRoleID) => {
    setModalData({ ...modalData, role_id: newRoleID });
  };

  const assignForOptions = useMemo(() => {
    return assignForRes.isSuccess && formRes.isSuccess ? assignForRes.data : [];
  }, [assignForRes, formRes]);

  const filteredUserList = useMemo(() => {
    if (missionActorCheck) {
      if (assignedUser) {
        setModalData((prev) => ({ ...prev, user_id: assignedUser.id }));
        return [assignedUser]
      }
      return []
    }
    return USER_ROLES.rr_srr.includes(parseInt(modalData.role_id))
      ? userList.filter((user) => modalData.mission_region_id === user.restrict_region_id)
      : userList.map((user) => ({
        id: user.id,
        name: user.name || user.role_name,
      }));
  }, [missionActorCheck, missionActors, modalData.role_id, modalData.mission_region_id, userList, assignedUser]);

    const showError = (message) => {
      setIsBtnLoading(false);
      displayNotification("error", `${t("-1", message)} [B]`);
    };

  const handleSave = async () => {
    try {
      setIsBtnLoading(true);

      if (!modalData.due_date || !dayjs(modalData.due_date).isValid()) {
        showError("Please select valid date");
        return;
      }
      if (!modalData.user_id) {
        showError("Please assign to User");
        return;
      }
      if (!modalData.role_id) {
        showError("Please select Role");
        return;
      }
      
      const data = await sendAPIRequest(`/api/pvsa/movement/${modalData.id}`, "PUT", modalData);
      const response = await data.json();
      if (response.success && response.status === 200) {
        setIsBtnLoading(false);
        initModal();
        displayNotification("success", `${t("-1", "Successfully Assigned")} `);
        missionContext.taskTrigger();
      } else {
        setIsBtnLoading(false);
        displayNotification("error", `${t("-1", "Error assigning a user")} [B]`);
      }
    } catch (e) {
      setIsBtnLoading(false);
      displayNotification("error", `${t("-1", "Error assigning a user")} [F]`);
    }
  };

  return (
    <Modal show={isShow} className="modal-lg">
      <Modal.Header className="p-4 " closeButton onClick={() => {
        setMissionActorCheck(true)
        initModal()
      }
      }>
        <Modal.Title>{modalData.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="row mt-3">
          <div className="col-12 mb-3">
            <label>
              <input
                type="radio"
                name="roleSelection"
                checked={missionActorCheck}
                onChange={() => setMissionActorCheck(true)}
              />
              {" Mission Actors"}
            </label>
            <label className="ms-3">
              <input
                type="radio"
                name="roleSelection"
                checked={!missionActorCheck}
                onChange={() => setMissionActorCheck(false)}
              />
              {" Roles"}
            </label>
          </div>
          <div className="col-6">
            <Autocomplete
              componentsProps={{
                paper: {
                  sx: {
                    "& .MuiAutocomplete-listbox": {
                      border: "1px solid black",
                    },
                  },
                },
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, 10],
                      },
                    },
                  ],
                },
              }}
              id="outlined-select-currency"
              options={newRoles}
              getOptionLabel={(option) => option.role_name || ""}
              value={newRoles?.find((role) => String(role.id) === String(modalData.role_id)) || null}
              onChange={(event, value) => {
                handleRoleChange(value?.id);
              }}
              // onChange={(event, value) => {
              //   setModalData({ ...modalData, role_id: value?.id })
              // }}
              fullWidth
              size="small"
              sx={{ marginTop: "10px" }}
              renderOption={(props, option, { selected }) => (
                <li
                  style={{
                    borderBottom: option !== newRoles[newRoles.length - 1] ? "1px solid black" : "none",
                  }}
                  {...props}
                >
                  {option.role_name}
                </li>
              )}
              renderInput={(params) => <TextFieldCustom {...params} label={"Role"} required={true} />}
              limitTags={2}
            />
          </div>
          <div className="col-6">
            <Autocomplete
              componentsProps={{
                paper: {
                  sx: {
                    "& .MuiAutocomplete-listbox": {
                      border: "1px solid black",
                    },
                  },
                },
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, 10],
                      },
                    },
                  ],
                },
              }}
              id="outlined-select-currency"
              options={filteredUserList}
              getOptionLabel={(option) => option.name || ""}
              value={filteredUserList?.find((user) => String(user.id) === String(modalData.user_id)) || null}
              onChange={(event, value) => {
                handlePopupValueChange(value?.id);
              }}
              // onChange={(event, value) => {
              //   setModalData({ ...modalData, user_id: value?.id })
              // }}
              fullWidth
              size="small"
              sx={{ marginTop: "10px" }}
              renderOption={(props, option, { selected }) => (
                <li
                  style={{
                    borderBottom: option !== userList[userList.length - 1] ? "1px solid black" : "none",
                  }}
                  {...props}
                >
                  {option.name}
                </li>
              )}
              renderInput={(params) => <TextFieldCustom {...params} label={t("-1", "Assign To")} required={true} />}
              limitTags={2}
            />
          </div>
          {
            formRes?.data?.type_ref !== 'FT_FRM' && (
              <div className="col-6">
                <Autocomplete
                  componentsProps={{
                    paper: {
                      sx: {
                        "& .MuiAutocomplete-listbox": {
                          border: "1px solid black",
                        },
                      },
                    },
                    popper: {
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, 10],
                          },
                        },
                      ],
                    },
                  }}
                  id="outlined-select-currency"
                  options={assignForOptions}
                  getOptionLabel={(option) => option.list_element_name}
                  value={assignForOptions.find((r) => String(r.id) === String(modalData.dform_assigned_for)) || null}
                  onChange={(event, value) => {
                    handlePopupAssignForValueChange(value?.id);
                  }}
                  fullWidth
                  size="small"
                  sx={{ marginTop: "10px" }}
                  renderOption={(props, option, { selected }) => {
                    if (
                      option.id === REPORT_ASSIGNMENT_STATUS.DRAFTED ||
                      option.id === REPORT_ASSIGNMENT_STATUS.PEER_REVIEWED_EVALUATION ||
                      option.id === REPORT_ASSIGNMENT_STATUS.PRELIMINARY_REPORT
                    ) {
                      return null;
                    }
                    return (
                      <li
                        style={{
                          borderBottom: option !== assignForOptions[assignForOptions.length - 1] ? "1px solid black" : "none",
                        }}
                        {...props}
                      >
                        {option.list_element_name}
                      </li>
                    )
                  }
                  }


                  renderInput={(params) => <TextFieldCustom {...params} label={t("-1", "Assign For")} required={false} />}
                  limitTags={2}
                />
              </div>
            )
          }

          <div className="col-6 mt-3">
            <DatePicker
              label={'Due Date'}
              allowSameDay={false}
              selected={
                modalData.due_date && ![null, ""].includes(modalData.due_date)
                  ? new Date(modalData.due_date)
                  : null
              }
              onChange={(date) =>
                setModalData({ ...modalData, due_date: date })
              }
              slotProps={{
                textField: {
                  size: "small",
                }
              }}
              sx={{
                "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-disabled": {
                  color: "#252525",
                },
              }}
              defaultValue={modalData.due_date}
              disablePast
              format="DD-MMM-YYYY"
              className="form-control"
              placeholderText="Click to select Date"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="p-4">
        <Button className="btn btn--primary" variant="" onClick={handleSave}>
          {isBtnLoading ? (
            <Spinner message="Saving..." />
          ) : (
            <>
              {t("85", "Save")}
              <i className="fa-sharp fas fa-check ms-2 text-white"></i>
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

MissionWorkflowModal.defaultProps = {
  isShow: false,
  initModal: () => { },
  modalData: {},
  setModalData: () => { },
};

export default MissionWorkflowModal;
